import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MenuItemsModel } from '@core/menu/menu.model';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { UserState } from '@core/state/user.state';
import { LoginResponse } from '@api/models/UserService/Contract/login-response';
import { AsyncPipe } from '@angular/common';
import { ClockComponent } from '@ui/elements/clock/clock.component';
import { PrintControlComponent } from '@ui/table/print-control/print-control.component';
import { Priv } from '@api/models/UserService/Contract/priv';
import { AppState } from '@core/state/app.state';
import { GetDbtimeResponse } from '@api/models/TariffEditorApi/Contract/get-dbtime-response';
import { ExportControlComponent } from '@ui/table/export-control/export-control.component';
import { filter, map } from 'rxjs/operators';
import { SubmenuComponent } from '@ui/layout/submenu/submenu.component';


/**
 * Navbar
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    imports: [
        AsyncPipe,
        ClockComponent,
        PrintControlComponent,
        ExportControlComponent,
        SubmenuComponent,
    ],
})
export class NavbarComponent {
    readonly #userState: UserState = inject(UserState);
    readonly #appState: AppState = inject(AppState);
    readonly #route: ActivatedRoute = inject(ActivatedRoute);

    /**
     * List menu items second level
     */
    public readonly items: MenuItemsModel[] = this.#route.snapshot.data.subMenuItems || [];
    /**
     * User data
     */
    public readonly user$: Observable<LoginResponse> = this.#userState.user$;
    /**
     * List user privileges
     */
    public readonly privs$: Observable<Priv[]> = this.user$.pipe(
        filter(Boolean),
        map((user: LoginResponse) => user.privs),
    );
    /**
     * Database time
     */
    public readonly databaseTime$: Observable<GetDbtimeResponse> = this.#appState.databaseTime$;
}
